import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { MarketdateMeterreadingPopupService } from './marketdate-meterreading-popup.service';
import { MarketdateMeterreadingService } from './marketdate-meterreading.service';

@Component({
    selector: 'jhi-marketdate-meterreading-delete-dialog',
    templateUrl: './marketdate-meterreading-delete-dialog.component.html'
})
export class MarketdateMeterreadingDeleteDialogComponent {

    marketdateMeterreading: MarketdateMeterreading;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketdateMeterreadingService: MarketdateMeterreadingService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketdateMeterreading', 'timestampType']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketdateMeterreadingService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketdateMeterreadingListModification',
                content: 'Deleted an marketdateMeterreading'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketdate-meterreading-delete-popup',
    template: ''
})
export class MarketdateMeterreadingDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketdateMeterreadingPopupService: MarketdateMeterreadingPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketdateMeterreadingPopupService
                .open(MarketdateMeterreadingDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading-delete-dialog.component.ts